function AuthorBackgroundLinesRightSVG() {
  return (
    <svg
      width="442"
      height="314"
      viewBox="0 0 442 314"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <line
          x1="266.353"
          y1="0.773268"
          x2="0.633913"
          y2="218.663"
          stroke="#FAB818"
          strokeWidth="2"
        />
        <line
          x1="453.92"
          y1="244.028"
          x2="23.682"
          y2="141.804"
          stroke="#F47521"
          strokeWidth="2"
        />
        <line
          x1="210.885"
          y1="0.255399"
          x2="128.203"
          y2="313.255"
          stroke="#2ABDBB"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export { AuthorBackgroundLinesRightSVG };
